

















































































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import Vuelidate from 'vuelidate';
import { required, minLength, between } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import vSelect from 'vue-select';
import { TransceiversApi, Transceiver, SitesApi } from '../../../api';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		secondaryNav,
		vSelect,
		Toast,
	},
	validations: {
		form: {
			// siteID: {required},
			uniqueId: { required },
			serialNumber: { required },
			imei: { required },
			type: { required },
		},
	},
	mixins: [validationMixin],
})
export default class TransceiverCreate extends Vue {
	public form = {
		// siteID: '',
		uniqueId: '',
		serialNumber: '',
		imei: '',
		type: null,
	};
	public errors = [];
	public sites: any = [];
	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public types = ['00', '01', '02', '03', '04'];
	constructor() {
		super();
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const transceiver: Transceiver = this.form;

		let response;
		try {
			response = await new TransceiversApi().addTransceiver({ data: transceiver });
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Creating Transceiver', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('New Transceiver', 'Successfully Created', 'success');
		this.submitStatus = 'OK';

		setTimeout(() => {
			this.$router.push({
				name: 'transceivers.view',
				params: { transceiverId: response.data.data.id },
			});
		}, 1000);
	}
}
